var _rect, _path, _path2, _path3, _ellipse, _ellipse2, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElevator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 10,
    width: 18,
    height: 18,
    fill: "#282D4B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6666 20.6667V18.3333C13.6666 17.781 13.2189 17.3333 12.6666 17.3333C12.1144 17.3333 11.6666 17.781 11.6666 18.3333V20.6667H13.6666ZM12.6666 16C11.378 16 10.3333 17.0447 10.3333 18.3333V22H15V18.3333C15 17.0447 13.9553 16 12.6666 16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3333 19.6667L16 22H22.6667L21.3333 19.6667V18C21.3333 16.8954 20.4379 16 19.3333 16C18.2288 16 17.3333 16.8954 17.3333 18V19.6667ZM20.3691 20.6667L20 20.0208V18C20 17.6318 19.7015 17.3333 19.3333 17.3333C18.9651 17.3333 18.6667 17.6318 18.6667 18V20.0208L18.2976 20.6667H20.3691Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 1.72388L23.1381 4.86195L22.1953 5.80476L20.6667 4.27616V8.00002H19.3333V4.27616L17.8047 5.80476L16.8619 4.86195L20 1.72388ZM11.3333 5.72388V2.00002H12.6667V5.72388L14.1953 4.19528L15.1381 5.13809L12 8.27616L8.86193 5.13809L9.80474 4.19528L11.3333 5.72388ZM6 9.33335H26V29.3333H6V9.33335ZM7.33333 10.6667V28H24.6667V10.6667H7.33333ZM12 26V22H13.3333V26H12ZM18.6667 26V22H20V26H18.6667Z",
    fill: "#282D4B"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.6666,
    cy: 14,
    rx: 1.33333,
    ry: 1.33333,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.3333,
    cy: 14,
    rx: 1.33333,
    ry: 1.33333,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 26V22H13.3333V26H12Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 26V22H20V26H18.6667Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElevator);
export default __webpack_public_path__ + "static/media/elevator.0a8055044a879d56622f24eda12eb9bb.svg";
export { ForwardRef as ReactComponent };